var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08594 1.04688L4.4375 4.60938C4.53125 4.72656 4.60156 4.86719 4.60156 4.98438C4.60156 5.125 4.53125 5.26562 4.4375 5.38281L1.08594 8.94531C0.875 9.17969 0.523438 9.17969 0.289062 8.96875C0.0546875 8.75781 0.0546875 8.40625 0.265625 8.17188L3.26562 4.98438L0.265625 1.82031C0.0546875 1.58594 0.0546875 1.23438 0.289062 1.02344C0.523438 0.8125 0.875 0.8125 1.08594 1.04688Z",
    fill: "#FFFBF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.0157f7afaadadf8803dda317e1d07754.svg";
export { ForwardRef as ReactComponent };